module.exports = __webpack_public_path__ + "static/long-walk-to-freedom-d4f465adbbc35a87860c2ece8c043669.jpg";